<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li
      class="breadcrumb-item"
      [class.active]="(items.length - 1) === i"
      *ngFor="let item of items; let i = index"
    >
      <a href="javascript:void(0)" (click)="onClick(item)">{{item.title}}</a>
    </li>
  </ol>
</nav>
